var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-snackbars',{attrs:{"messages":_vm.messages,"color":_vm.color,"top":"","right":""},on:{"update:messages":function($event){_vm.messages=$event}}})}
var staticRenderFns = []

export { render, staticRenderFns }